import { useState, useEffect } from "react";
import PageFooter from "../../Organisms/PageFooter/PageFooter";
import "./AppLayout.scss";
import ButtonToTop from "../../Atoms/ButtonToTop/ButtonToTop";
import PopUp from "../../Atoms/PopUp/PopUp";

export const AppLayout = ({ children }) => {
	const [appearTopButton, setAppearTopButton] = useState(false);

	const showButtonHandler = () => {
		if (window.scrollY > 1300) {
			setAppearTopButton(true);
		} else if (window.scrollY < 1300) {
			setAppearTopButton(false);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", showButtonHandler);

		return () => window.removeEventListener("scroll", showButtonHandler);
	}, []);

	return (
		<div className="foresight-app">
			<PopUp />
			<main className="foresight-app-content"> {children} </main>
			<ButtonToTop appearTopButton={appearTopButton} />
			<PageFooter />
		</div>
	);
};
